import { SimulatorDashboardComponent } from './containers/simulator-dashboard/simulator-dashboard.component';
import { IotAppComponent } from './containers/iot-app/iot-app.component';
export const routes = [
  { path: 'id/:id', component: SimulatorDashboardComponent },
  { path: 'mobile-app', component: IotAppComponent },
  { path: 'mobile-app/:app-id', component: IotAppComponent }
];
